import { Button, Typography } from "@mui/material";
import { useState } from "react";
import TSGrid from "../../../common/components/ui/TSGrid";
import SujetSection from "./SujetSection";

const Footer = ({isMidium}) => {
  const [openGuide, setOpenGuide] = useState(false);

  return (
    <TSGrid
      container
      justifyContent="center"
      sx={{ textAlign: "center", mt: 3, ...(isMidium && { mt: 0 }) }}
    >
          <TSGrid item xs={12} sx={{ mt: 2 }}>
            <Typography
              sx={{
                mb: 2,
                fontFamily: "Poppins",
                fontSize: "13px",
                color: "#FFFFFF",
                fontWeight: 500,
                lineHeight: "17.34px",
                textAlign: "center",
                textUnderlinePosition: "from-font",
                textDecorationSkipInk: "none",
                ...(isMidium && { mb: 0 }),
              }}
            >
              Vous souhaitez faire une recherche par régime ?
            </Typography>
            <Button
              variant="contained"
              sx={{
                background:
                  "linear-gradient(274.25deg, #2DC5EE -48.01%, #15C087 140.23%)",
                color: "#fff",
                padding: "5px 40px",
                borderRadius: "9px",
                textTransform: "none",
                "&:hover": {
                  background:
                    "linear-gradient(90deg, rgb(84, 131, 86) 0%, rgb(17, 111, 118) 100%)",
                },
              }}
              onClick={() => setOpenGuide(!openGuide)}
            >
              Recherche Guidée
            </Button>
          </TSGrid>
       
       {openGuide && ( <TSGrid item xs={11} sm={10} md={9}>
          <SujetSection />
        </TSGrid>
      )}
    </TSGrid>
  );
};

export default Footer;
